import type { VenueDetailAmenitiesComponent } from '../../../types/sdui-arena-detail'
import { AmenitiesSection } from '../../AmenitiesSection'
import type { ArenaAmenity } from '../../../types/arena'

interface VenueDetailAmenitiesProps {
  config: VenueDetailAmenitiesComponent
}

export function VenueDetailAmenities({ config }: VenueDetailAmenitiesProps) {
  const { amenities } = config

  // Convert to AmenitiesSection format
  const formattedAmenities: ArenaAmenity[] = amenities.map(a => a.type as ArenaAmenity)

  return <AmenitiesSection amenities={formattedAmenities} />
}
